<template>
  <div>
    <!-- Button trigger modal -->
    <button
      type="button"
      class="btn btn-pmain d-none"
      data-bs-toggle="modal"
      :data-bs-target="`#${modalId}`"
      ref="openMoalBtn"
    >OpenMoedal</button>

    <!-- Modal -->
    <div
      class="modal"
      :id="modalId"
      tabindex="-1"
      ref="modal2"
      @click.prevent="clickModalArea"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        :class="{
          'animate__animated': true,
          'animate__fadeIn': fadeIn
        }"
        @click.prevent="clickDialogArea"
      >
        <div class="modal-content">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            ref=dismissModalBtn
            @click="clickCloseBtn"
          ></button>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal2",
  props: {
    modalId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fadeIn: false,
      clickTarget: "",
    };
  },
  // beforeUnmount() {
  beforeUnmount() {
    this.closeModal();
  },
  methods: {
    async openModal() {
      this.$refs.openMoalBtn.click();
      this.fadeIn = true;
    },
    async closeModal() {
      this.$refs.dismissModalBtn.click();
      this.fadeIn = false;
    },
    clickCloseBtn() {
      this.$emit("close");
    },
    clickDialogArea() {
      if (this.clickTarget === "") {
        this.clickTarget = "dialog";
      }
    },
    clickModalArea() {
      if (this.clickTarget === "") {
        this.$emit("close");
      }
      this.clickTarget = "";
    },
  },
};
</script>
